import { render, staticRenderFns } from "./CreateFramework.vue?vue&type=template&id=220ed0f7&"
import script from "./CreateFramework.vue?vue&type=script&lang=js&"
export * from "./CreateFramework.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports